import {
  take,
  fork,
  call,
  put,
  all,
  takeEvery,
  cancel
} from "redux-saga/effects";
import asyncInterface from "../../../../asyncInterface";
import history from "../../../../history/history";
import formPoolStructure from "../../../../utils/formPoolStructure";
import { decodeName } from "../../../../utils/nameFormatter";
import { getAccountData, getPrimaryAccount } from "../../../../utils/sessionUtil";
import { exchangesApi } from "../../../../services/apiServices";
import _ from "lodash";

import {
  fetchPoolDataType,
  fetchUnderlyingFundsType,
  initializeFromPoolsType,
  initializeToPoolsType,
  makeFromToPoolsType,
  validateFromPoolsStateType,
  validateToPoolsType,
  validateSubmitType,
  switchInvestmentOptionType,
  toggleInvestmentOptionModalType,
  fetchAllPoolDataType,
  fetchTradeDateType,
  submitExchangeUpdateType,
  submitExchangeUpdateToType,
  activeExchangeScheduleCountType,
  fetchCustomPoolFeeType,
  fetchCustomPoolFeeSuccessType,
  fetchCustomPoolFeeFailedType
} from './actionTypes'


export function fetchPoolData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.recommendAnExchange.fetchAccountData(fetchPayload);
}

export function validateFromToPools(toOrFrom) {
  let isValidated = false;
  const arr = [];
  for (const eachType in toOrFrom) {
    if (Object.prototype.hasOwnProperty.call(toOrFrom, eachType)) {
      for (const pool in toOrFrom[eachType]) {
        if (Object.prototype.hasOwnProperty.call(toOrFrom[eachType], pool)) {
          if (Object.keys(toOrFrom[eachType][pool]).length > 0) {
            isValidated = true;
            arr.push(pool);
            break;
          }
        }
      }
    }
  }
  if (arr.length === 2) {
    return [true, true];
  }
  if (isValidated) {
    return true;
  }
  return false;
}

export function* makePoolsWorker(action) {
  const poolsObj = formPoolStructure(action.payload);
  yield all([
    put({ type: initializeFromPoolsType, payload: poolsObj })
  ]);
}
 export function* makePoolsStateWatcher() {
  yield takeEvery(makeFromToPoolsType, makePoolsWorker);
}

export function* makeToPoolsWorker(action) {
  const poolsObj = formPoolStructure(action.payload);
  yield all([
    put({ type: initializeToPoolsType, payload: poolsObj })
  ]);
}

export function* makeToPoolsStateWatcher() {
  yield takeEvery("MAKE_TO_POOLS", makeToPoolsWorker);
}

export function* validateFromPoolsWorker(action) {
  const { fromPool } = action.payload;
  const isValidated = validateFromToPools({ fromPool });
  if (action.payload.isEdit) {
    if (isValidated)
      yield call(history.push, "/recommendAnExchange/viewAndSubmit");
  } else {
    if (isValidated)
      yield call(
        history.push,
        "/recommendAnExchange/recommendAnExchangeTo"
      );
  }
}

export function* validateToPoolsWorker(action) {
  const { toPools } = action.payload;
  const isValidated = validateFromToPools({ toPools });
  if (isValidated)
    yield call(history.push, "/recommendAnExchange/viewAndSubmit");
}

export function* validateFromPoolsWatcher() {
  yield takeEvery(validateFromPoolsStateType, validateFromPoolsWorker);
}
export function findPoolId(poolName, dataArr) {
  const poolSelected = _.filter(dataArr, v => {
    return _.includes(poolName, v.poolName);
  });
  return poolSelected[0]?.poolId;
}

export function submitData(actionObj) {
  const { method, url, data } = actionObj.payload;
  const {
    exchangeFromPool,
    exchangeToPool
  } = data;

  let exchangeUnit = "";
  let activeUnit = '';
  if (exchangeFromPool.activeExchangeUnit.toUpperCase() === "DOLLARS") {
    exchangeUnit = "DOLLAR";
    activeUnit = 'dollarAmount';
  } else if (exchangeFromPool.activeExchangeUnit.toUpperCase() === "UNITS") {
    exchangeUnit = "UNITS";
    activeUnit = 'units';
  } else if (exchangeFromPool.activeExchangeUnit.toUpperCase() === "PERCENTAGE") {
    exchangeUnit = "PERCENT";
    activeUnit = 'percentage';
  }
  const response = asyncInterface.init();
  return response.recommendAnExchange.submitExchange({
    method,
    url,
    data: {
      accountId: getPrimaryAccount().userId,
      partyId: `${getAccountData().partyId}`,
      startDate: exchangeFromPool.oneTime.startDate,
      category: "Single Exchange",
      exchangeType: exchangeFromPool.oneTime.exchangeType,
      unit: exchangeUnit,
      exchangeFrom: (function () {
        const arr = [];
        exchangeFromPool.poolData.investmentPools.forEach((obj, i) => {
          arr.push({
            poolId: obj.poolId,
            pool: obj.poolName,
            value: obj[activeUnit]
          })
        })
        return arr;
      })(),
      exchangeTo: (function () {
        const arr = [];
        exchangeToPool.toPool.forEach((obj, i) => {
          arr.push({
            poolId: obj.poolId,
            pool: obj.poolName,
            value: obj.percentageAllocation
          })
        })

        return arr;
      })()
    }
  });
}

export function submitRecurringData(actionObj) {
  const { method, url, data } = actionObj.payload;
  const {
    exchangeFromPool,
    exchangeToPool
  } = data;
  let exchangeUnit = "";
  let activeUnit = '';
  if (exchangeFromPool.activeExchangeUnit.toUpperCase() === "DOLLARS") {
    exchangeUnit = "DOLLAR";
    activeUnit = 'dollarAmount';
  } else if (exchangeFromPool.activeExchangeUnit.toUpperCase() === "UNITS") {
    exchangeUnit = "UNITS";
    activeUnit = 'units';
  } else if (exchangeFromPool.activeExchangeUnit.toUpperCase() === "PERCENTAGE") {
    exchangeUnit = "PERCENT";
    activeUnit = 'percentage';
  }
  const response = asyncInterface.init();
  return response.recommendAnExchange.submitExchange({
    method,
    url,
    data: {
      accountId: getPrimaryAccount().userId,
      partyId: `${getAccountData().partyId}`,
      startDate: exchangeFromPool.recurring.startDate.format("YYYY-MM-DD"),
      endDate: exchangeFromPool.recurring.endDate.format("YYYY-MM-DD"),
      frequency: exchangeFromPool.recurring.frequency,
      startDay: exchangeFromPool.recurring.startDate.format("dddd"),
      exchangeType: "Custom Exchange",
      numberOfExchanges: exchangeFromPool.recurring.numberOfExchanges,
      category: "Recurring Exchange",
      unit: exchangeUnit,
      exchangeFrom: (function () {
        const arr = [];
        exchangeFromPool.poolData.investmentPools.forEach((obj, i) => {
          arr.push({
            poolId: obj.poolId,
            pool: obj.poolName,
            value: obj[activeUnit]
          })
        })
        return arr;
      })(),
      exchangeTo: (function () {
        const arr = [];
        exchangeToPool.toPool.forEach((obj, i) => {
          arr.push({
            poolId: obj.poolId,
            pool: obj.poolName,
            value: obj.percentageAllocation
          })
        })
        return arr;
      })()
    }
  });
}

export function* validateSubmitWorker(actionObj) {
  if (actionObj.payload.data.typeActive === "oneTime") {

    const response = yield call(submitData, actionObj);
    yield put({ type: "SUBMIT_FORM_SUCCESS_RAE", payload: response.data });
    history.push({
      pathname: `/ExchangeConfirmation/${response.data.txnId}`,
      state: { txn: 'oneTime', page: 'submit' }
    });
  } else if (actionObj.payload.data.typeActive === "recurring") {
    const response = yield call(submitRecurringData, actionObj);
    yield put({ type: "SUBMIT_FORM_SUCCESS_RAE", payload: response.data });
    history.push({
      pathname: `/ExchangeConfirmation/${response.data.scheduleId}`,
      state: { txn: 'recurring', page: 'submit' }
    });
  }
}

export function* switchInvestmentOptionWorker(actionPayload) {
  const { fromPool, toPool } = actionPayload;
  yield put({ type: toggleInvestmentOptionModalType });
  const isValidated = validateFromToPools({ fromPool, toPool });
  return isValidated;
}

export function* poolDataWorker(fetchPayload) {
  try {
    const fetchObj = fetchPayload.payload.metaData;
    const fetchUrls = fetchPayload.payload.metaData.url;
    const isExternal = fetchPayload.payload.metaData.isExternal;
    const fetchArr = [];
    for (const key in fetchUrls) {
      if (Object.prototype.hasOwnProperty.call(fetchUrls, key)) {
        const keyObj = Object.assign({
          method: fetchObj.method,
          url: fetchUrls[key],
          isExternal: isExternal
        });
        fetchArr.push(keyObj);
      }
    }

    const fetchedArr = yield all(
      fetchArr.map(each => call(fetchPoolData, each))
    );

    if (fetchPayload.payload.metaData.page === "recommendAnExchange") {
      yield put({
        type: "POOL_DATA_SUCCESS",
        payload: fetchedArr[0].data
      });
      yield put({
        type: "POOL_DATA_SUCCESS_SET",
        payload: true
      });
    }
  } catch (error) {
    yield put({
      type: "POOL_DATA_REQUEST_FAILED",
      error
    });
  }
}

export function* fetchAllPoolDataWorker(fetchPayload) {
  try {
    const fetchObj = fetchPayload.payload.metaData;
    const fetchUrls = fetchPayload.payload.metaData.url;
    const isExternal = fetchPayload.payload.metaData.isExternal;
    const fetchArr = [];
    for (const key in fetchUrls) {
      if (Object.prototype.hasOwnProperty.call(fetchUrls, key)) {
        const keyObj = Object.assign({
          method: fetchObj.method,
          url: fetchUrls[key],
          isExternal: isExternal
        });
        fetchArr.push(keyObj);
      }
    }

    const fetchedArr = yield all(
      fetchArr.map(each => call(fetchPoolData, each))
    );

    if (fetchPayload.payload.metaData.page === "recommendAnExchange") {
      yield put({
        type: "ALL_POOL_DATA_SUCCESS",
        payload: fetchedArr[0].data
      });
      yield put({
        type: "ALL_POOL_DATA_SUCCESS_SET",
        payload: true
      });
    }
  } catch (error) {
    yield put({
      type: "ALL_POOL_DATA_REQUEST_FAILED",
      error
    });
  }
}

export function* underlyingFundsWorker(fetchPayload) {
  try {
    const fetchObj = fetchPayload.payload.metaData;
    const fetchUrls = fetchPayload.payload.metaData.url;
    const isExternal = fetchPayload.payload.metaData.isExternal;
    const fetchArr = [];
    for (const key in fetchUrls) {
      if (Object.prototype.hasOwnProperty.call(fetchUrls, key)) {
        const keyObj = Object.assign({
          method: fetchObj.method,
          url: fetchUrls[key],
          isExternal: isExternal
        });
        fetchArr.push(keyObj);
      }
    }

    const fetchedArr = yield all(
      fetchArr.map(each => call(fetchPoolData, each))
    );

    if (fetchPayload.payload.metaData.page === "recommendAnExchange") {
      yield put({
        type: "UNDERLYING_DATA_SUCCESS",
        payload: fetchedArr[0].data
      });
      yield put({
        type: "UNDERLYING_DATA_SUCCESS_SET",
        payload: true
      });
    }
  } catch (error) {
    yield put({
      type: "UNDERLYING_DATA_REQUEST_FAILED",
      error
    });
  }
}

// schedule Worker
export function* scheduleCountWorker(fetchPayload) {
  try {
    const fetchObj = fetchPayload.payload.metaData;
    const fetchUrls = fetchPayload.payload.metaData.url;
    const isExternal = fetchPayload.payload.metaData.isExternal;
    const fetchArr = [];
    for (const key in fetchUrls) {
      if (Object.prototype.hasOwnProperty.call(fetchUrls, key)) {
        const keyObj = Object.assign({
          method: fetchObj.method,
          url: fetchUrls[key],
          isExternal: isExternal
        });
        fetchArr.push(keyObj);
      }
    }

    const fetchedArr = yield all(
      fetchArr.map(each => call(fetchPoolData, each))
    );

    if (fetchPayload.payload.metaData.page === "recommendAnExchange") {
      yield put({
        type: "SCHEDULE_COUNT_SUCCESS",
        payload: fetchedArr[0].data
      });

    }
  } catch (error) {
    yield put({
      type: "SCHEDULE_COUNT_REQUEST_FAILED",
      error
    });
  }
}

// Trade date worker
export function* tradeDateWorker(fetchPayload) {
  try {
    const fetchObj = fetchPayload.payload.metaData;
    const fetchUrls = fetchPayload.payload.metaData.url;
    const isExternal = fetchPayload.payload.metaData.isExternal;
    const fetchArr = [];
    for (const key in fetchUrls) {
      if (Object.prototype.hasOwnProperty.call(fetchUrls, key)) {
        const keyObj = Object.assign({
          method: fetchObj.method,
          url: fetchUrls[key],
          isExternal: isExternal
        });
        fetchArr.push(keyObj);
      }
    }

    const fetchedArr = yield all(
      fetchArr.map(each => call(fetchPoolData, each))
    );

    if (fetchPayload.payload.metaData.page === "recommendAnExchange") {
      yield put({
        type: "TRADE_DATA_SUCCESS",
        payload: fetchedArr[0].data
      });
      yield put({
        type: "TRADE_DATA_SUCCESS_SET",
        payload: true
      });
    }
  } catch (error) {
    yield put({
      type: "TRADE_DATA_REQUEST_FAILED",
      error
    });
  }
}

export function* validateToPoolsWatcher() {
  yield takeEvery(validateToPoolsType, validateToPoolsWorker);
}

export function* validateSubmitWatcher() {
  const actionObj = yield take(validateSubmitType);
  yield call(validateSubmitWorker, actionObj);
}

export function* switchInvestmentOptionWatcher() {
  const actionObj = yield take(switchInvestmentOptionType);
  const isValidated = yield fork(
    switchInvestmentOptionWorker,
    actionObj.payload
  );
  yield cancel(isValidated);
}

export function ExchangeUpdateWorker(actionObj) {
  const { method, url, data } = actionObj.payload;
  const {
    oneTime,
    recurring,
    fromPool,
    typeActive,
    toFrom,
    viewExchange
  } = data;

  let exchangeUnit = "";
  if (fromPool.activeExchangeUnit.toUpperCase() === "DOLLARS") {
    exchangeUnit = "DOLLAR";
  } else if (fromPool.activeExchangeUnit.toUpperCase() === "UNITS") {
    exchangeUnit = "UNITS";
  } else if (fromPool.activeExchangeUnit.toUpperCase() === "PERCENTAGE") {
    exchangeUnit = "PERCENT";
  }
  const response = asyncInterface.init();
  if (typeActive === "oneTime") {
    return response.recommendAnExchange.submitExchange({
      method,
      url,
      data: {
        accountId: getPrimaryAccount().userId,
        partyId: getAccountData().partyId,
        txnId: viewExchange.data.singleExchange.transactionId,
        startDate: viewExchange.data.singleExchange.enteredDate,
        category: "Single Exchange",
        exchangeType: oneTime.exchangeType,
        unit: exchangeUnit,
        exchangeFrom: (function () {
          const arr = [];
          for (const pool in fromPool.form) {
            if (
              Object.prototype.hasOwnProperty.call(
                fromPool.form,
                pool,
                fromPool
              )
            ) {
              const unitActive = fromPool.activeExchangeUnit;
              arr.push({
                poolId: findPoolId(decodeName(pool), toFrom.data),
                pool: decodeName(pool),
                value: fromPool.form[pool][unitActive]
              });
            }
          }
          return arr;
        })(),
        exchangeTo: viewExchange.data.singleExchange.exchangeTo
      }
    });
  } else if (typeActive === "recurring") {
    return response.recommendAnExchange.submitExchange({
      method,
      url,
      data: {
        accountId: getPrimaryAccount().userId,
        partyId: getAccountData().partyId,
        scheduleId: viewExchange.data.recurringExchange.exchScheduleId,
        startDate: viewExchange.data.recurringExchange.exchScheduleId,
        endDate: recurring.endDate.format("YYYY-MM-DD"),
        frequency: viewExchange.data.recurringExchange.frequency,
        exchangeType: "Custom Exchange",
        numberOfExchanges: recurring.numberOfExchanges,
        category: "Recurring Exchange",
        unit: exchangeUnit,
        exchangeFrom: (function () {
          const arr = [];
          for (const pool in fromPool.form) {
            if (
              Object.prototype.hasOwnProperty.call(
                fromPool.form,
                pool,
                fromPool
              )
            ) {
              const unitActive = fromPool.activeExchangeUnit;
              arr.push({
                poolId: findPoolId(decodeName(pool), toFrom.data),
                pool: decodeName(pool),
                value: fromPool.form[pool][unitActive]
              });
            }
          }
          return arr;
        })(),

        exchangeTo: viewExchange.data.recurringExchange.exchangeTo
      }
    });
  } else if (typeActive === "spawn") {
  }
}


export function ExchangeUpdateToWorker(actionObj) {
  const { method, url, data } = actionObj.payload;
  const {
    recurring,
    typeActive,
    toPool,
    toFrom,
    viewExchange
  } = data;


  const response = asyncInterface.init();
  if (typeActive === "oneTime") {
    return response.recommendAnExchange.submitExchange({
      method,
      url,
      data: {
        accountId: getPrimaryAccount().userId,
        partyId: getAccountData().partyId,
        txnId: viewExchange.data.singleExchange.transactionId,
        startDate: viewExchange.data.singleExchange.enteredDate,
        category: "Single Exchange",
        exchangeType: viewExchange.data.singleExchange.exchangeType,
        unit: viewExchange.data.singleExchange.instructionType,
        exchangeFrom: viewExchange.data.singleExchange.exchangeFrom,
        exchangeTo: (function () {
          const arr = [];
          for (const pool in toPool.form) {
            if (Object.prototype.hasOwnProperty.call(toPool.form, pool)) {
              arr.push({
                poolId: findPoolId(decodeName(pool), toFrom.data),
                pool: decodeName(pool),
                percentage: toPool.form[pool].Percentage
              });
            }
          }

          return arr;
        })()
      }
    });
  } else if (typeActive === "recurring") {
    return response.recommendAnExchange.submitExchange({
      method,
      url,
      data: {
        accountId: getPrimaryAccount().userId,
        partyId: getAccountData().partyId,
        scheduleId: viewExchange.data.recurringExchange.exchScheduleId,
        startDate: viewExchange.data.recurringExchange.exchScheduleId,
        endDate: recurring.endDate.format("YYYY-MM-DD"),
        frequency: viewExchange.data.recurringExchange.frequency,
        exchangeType: "Custom Exchange",
        numberOfExchanges: recurring.numberOfExchanges,
        category: "Recurring Exchange",
        unit: viewExchange.data.singleExchange.allocationType,
        exchangeFrom: viewExchange.data.singleExchange.exchangeFrom,
        exchangeTo: (function () {
          const arr = [];
          for (const pool in toPool.form) {
            if (Object.prototype.hasOwnProperty.call(toPool.form, pool)) {
              arr.push({
                poolId: findPoolId(decodeName(pool), toFrom.data),
                pool: decodeName(pool),
                percentage: toPool.form[pool].Percentage
              });
            }
          }

          return arr;
        })()
      }
    });
  } else if (typeActive === "spawn") {
  }
}

export function* getCustomPoolFeeWorker(action) {
  try {
    const response = yield call(
      exchangesApi.customPoolFee,
      action.payload
    );
    yield put({
      type: fetchCustomPoolFeeSuccessType,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: fetchCustomPoolFeeFailedType, error });
  }
}


export function* customPoolFeeWatcher() {
  yield takeEvery(fetchCustomPoolFeeType, getCustomPoolFeeWorker);
}

export function* poolDataWatcher() {
  yield takeEvery(fetchPoolDataType, poolDataWorker);
}

export function* underlyingFundsWatcher() {
  yield takeEvery(fetchUnderlyingFundsType, underlyingFundsWorker);
}

export function* fetchAllPoolData() {
  yield takeEvery(fetchAllPoolDataType, fetchAllPoolDataWorker);
}

export function* tradeDateWatcher() {
  yield takeEvery(fetchTradeDateType, tradeDateWorker);
}

export function* submitExchangeUpdate() {
  yield takeEvery(submitExchangeUpdateType, ExchangeUpdateWorker);
}

export function* submitExchangeUpdateTo() {
  yield takeEvery(submitExchangeUpdateToType, ExchangeUpdateToWorker);
}

export function* scheduleCountWatcher() {
  yield takeEvery(activeExchangeScheduleCountType, scheduleCountWorker)
}

export default function* recommendAnExchangeWatcher() {
  yield all([
    fork(makePoolsStateWatcher),
    fork(validateFromPoolsWatcher),
    fork(validateToPoolsWatcher),
    fork(validateSubmitWatcher),
    fork(switchInvestmentOptionWatcher),
    fork(poolDataWatcher),
    fork(underlyingFundsWatcher),
    fork(fetchAllPoolData),
    fork(tradeDateWatcher),
    fork(makeToPoolsStateWatcher),
    fork(submitExchangeUpdate),
    fork(submitExchangeUpdateTo),
    fork(scheduleCountWatcher),
    fork(customPoolFeeWatcher)
  ]);
}
